import React, { useRef, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import {
  Container,
  Box,
  Divider,
  CardContent,
  Button,
  Typography,
  Popover,
  OutlinedInput,
  FormControl,
  InputLabel,
  IconButton,
  InputAdornment,
} from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import MainLogos from '../../assets/main-logos.svg';
import LogoExtended from '../../assets/extendedLogo.svg';
import api from '../../services/api';
import { optionStyles } from './style';
import ShowSnackbar, { SetSnackbarType } from '../../components/SnackBar';
import Colors from '../../components/Colors';

interface FormData {
  usarname: string;
  password: string;
}

interface User {
  groups: string[];
}

const Register: React.FC = () => {
  const classes = optionStyles();
  const [err, setErr] = useState<boolean>(false);
  const history = useHistory();
  const [userName, setUserName] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [showPassoword, setShowPassword] = useState<boolean>(true);
  const [snackBar, setSnackbar] = useState<SetSnackbarType>({ open: false, message: '' });

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const formRef = useRef<FormHandles>(null);

  const handleSubmit = async (data = { username: userName, email, password }) => {
    await api.post('/create_public_user/', data).then(() => {
      setSnackbar({open: true, message: "Usuário criado com sucesso! \n Você já pode realizar o login."})
      history.push('/login');
    }).catch(()=> {
      setSnackbar({open: true, message: 'Falha ao criar a conta'})
    });
  };

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };

  const handleUserNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUserName(event.target.value);
  };

  const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(event.target.value);
  };

  const handleShowPassword = () => {
    setShowPassword(!showPassoword);
  };

  return (
    <Container maxWidth="xl" className={classes.rootContainer}>
      <Box className={classes.rootCard}>
        <CardContent className={classes.cardContent}>
          <img src={LogoExtended} alt="Logo VIDA" width="200" className={classes.logo} />
          <Divider className={classes.divider} orientation="horizontal" />
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'flex-start',
            }}
          >
            <Typography variant="h6" style={{ color: '#1D1D1B', marginBottom: '5%' }}>
              Criar uma nova conta
            </Typography>
          </div>
          <Form className={classes.rootForm} ref={formRef} onSubmit={handleSubmit}>
            {err && (
              <Typography
                variant="subtitle2"
                style={{ color: '#90002B', marginBottom: '5%' }}
              >
                Não foi possível registrar, tente novamente.
              </Typography>
            )}
            <FormControl variant="outlined">
              <InputLabel htmlFor="username">Nome de usuário para acesso</InputLabel>
              <OutlinedInput
                id="username"
                name="username"
                type="text"
                label="Nome de usuário para acesso"
                required
                placeholder="Nome de usuário para acesso"
                className={classes.input}
                value={userName}
                onChange={handleUserNameChange}
              />
            </FormControl>
            <FormControl variant="outlined">
              <InputLabel htmlFor="email">E-mail</InputLabel>
              <OutlinedInput
                id="email"
                name="email"
                label="E-mail"
                type="email"
                required
                placeholder="E-mail"
                className={classes.input}
                value={email}
                onChange={handleEmailChange}
              />
            </FormControl>
            <FormControl variant="outlined">
              <InputLabel htmlFor="password">Senha de acesso</InputLabel>
              <OutlinedInput
                id="password"
                name="password"
                label="Senha de acesso:"
                type={showPassoword ? 'password' : 'text'}
                required
                placeholder="Senha de acesso"
                className={classes.input}
                value={password}
                onChange={handlePasswordChange}
                endAdornment={(
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleShowPassword}
                      onMouseDown={handleShowPassword}
                    >
                      {showPassoword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                )}
              />
            </FormControl>

            <Button
              variant="outlined"
              className={classes.rootButton}
              onClick={() => handleSubmit()}
            >
              Registrar
            </Button>
          </Form>
          <div className={classes.linksContainer}>
            <Link className={classes.link} to="/login">
              Já possuo acesso
            </Link>
          </div>
        </CardContent>
        <img src={MainLogos} alt="Logo VIDA" className={classes.mainLogos} />
      </Box>
      <Popover
        id="mouse-over-popover"
        className={classes.popover}
        classes={{
          paper: classes.paper,
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Typography>
          Sua senha será
          <span style={{ fontWeight: 'bolder', color: Colors.main }}>public</span>.
        </Typography>
      </Popover>
      <ShowSnackbar
        open={snackBar.open}
        message={snackBar.message}
        setSnackbar={setSnackbar}
      />
    </Container>
  );
};

export default Register;
